/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Monthly_CostInputs */



/**
* | output |
* | --- |
* | "Monthly cost" |
*
* @param {Sub_Downgrade_Monthly_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_monthly_cost = /** @type {((inputs?: Sub_Downgrade_Monthly_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Monthly_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Monatliche Kosten")
	return /** @type {LocalizedString} */ ("Monthly cost")
});